// PUREGLOSS CLUB offer (2026): €25 welcome voucher for any service from €100 order value.
const COPY = {
  de: {
    amount: "25 €", badge: "Willkommensbonus",
    headline: "25 € WILLKOMMENSBONUS",
    offer: "Ihr exklusiver 25 € Gutschein für jede PUREGLOSS Dienstleistung ab 100 € Auftragswert.",
    benefitsTitle: "Ihre Vorteile",
    benefits: ["25 € Willkommensgutschein ab 100 € Auftragswert.", "Frühzeitiger Zugang zu Aktionen und Angeboten.", "Exklusive Vorteile für PUREGLOSS CLUB Mitglieder."],
    cta: "Kostenlos Mitglied werden",
    finePrint: "Gutschein 6 Monate gültig, einmalig einlösbar, nicht in bar auszahlbar. Mindestauftragswert 100 €.",
    success: "Ihr 25 € Willkommensgutschein ist aktiviert. Er gilt für jede PUREGLOSS Dienstleistung ab 100 € Auftragswert.",
  },
  ua: {
    amount: "25 €", badge: "Вітальний бонус",
    headline: "ВІТАЛЬНИЙ БОНУС 25 €",
    offer: "Ваш ексклюзивний ваучер на 25 € для будь-якої послуги PUREGLOSS від 100 € вартості замовлення.",
    benefitsTitle: "Ваші переваги",
    benefits: ["Вітальний ваучер 25 € від 100 € вартості замовлення.", "Ранній доступ до акцій і пропозицій.", "Ексклюзивні переваги для учасників PUREGLOSS CLUB."],
    cta: "Стати учасником безкоштовно",
    finePrint: "Ваучер дійсний 6 місяців, використовується один раз, не обмінюється на готівку. Мінімальна сума замовлення 100 €.",
    success: "Ваш вітальний ваучер на 25 € активовано. Він діє для будь-якої послуги PUREGLOSS від 100 € вартості замовлення.",
  },
  en: {
    amount: "€25", badge: "Welcome bonus",
    headline: "€25 WELCOME BONUS",
    offer: "Your exclusive €25 voucher for any PUREGLOSS service with a minimum order value of €100.",
    benefitsTitle: "Your benefits",
    benefits: ["€25 welcome voucher from €100 order value.", "Early access to promotions and special offers.", "Exclusive PUREGLOSS CLUB member benefits."],
    cta: "Join for free",
    finePrint: "Voucher valid for 6 months, single use, not redeemable for cash. Minimum order value €100.",
    success: "Your €25 welcome voucher is active. It applies to any PUREGLOSS service with a minimum order value of €100.",
  },
  pl: {
    amount: "25 €", badge: "Bonus powitalny",
    headline: "BONUS POWITALNY 25 €",
    offer: "Twój ekskluzywny bon 25 € na dowolną usługę PUREGLOSS przy zamówieniu od 100 €.",
    benefitsTitle: "Twoje korzyści",
    benefits: ["Bon powitalny 25 € przy zamówieniu od 100 €.", "Wcześniejszy dostęp do promocji i ofert.", "Ekskluzywne korzyści dla członków PUREGLOSS CLUB."],
    cta: "Dołącz bezpłatnie",
    finePrint: "Bon ważny 6 miesięcy, jednorazowy, niewymienialny na gotówkę. Minimalna wartość zamówienia 100 €.",
    success: "Twój bon powitalny 25 € jest aktywny. Obowiązuje na dowolną usługę PUREGLOSS przy zamówieniu od 100 €.",
  },
  ru: {
    amount: "25 €", badge: "Приветственный бонус",
    headline: "ПРИВЕТСТВЕННЫЙ БОНУС 25 €",
    offer: "Ваш эксклюзивный ваучер на 25 € на любую услугу PUREGLOSS при заказе от 100 €.",
    benefitsTitle: "Ваши преимущества",
    benefits: ["Приветственный ваучер 25 € при заказе от 100 €.", "Ранний доступ к акциям и предложениям.", "Эксклюзивные преимущества для участников PUREGLOSS CLUB."],
    cta: "Стать участником бесплатно",
    finePrint: "Ваучер действует 6 месяцев, используется один раз, не обменивается на наличные. Минимальная сумма заказа 100 €.",
    success: "Ваш приветственный ваучер на 25 € активирован. Он действует на любую услугу PUREGLOSS при заказе от 100 €.",
  },
};

export const clubCopy = (lang) => COPY[lang] || COPY.de;
